import { render, staticRenderFns } from "./SpecialistSection.vue?vue&type=template&id=43bf43a8"
import script from "./SpecialistSection.vue?vue&type=script&lang=js"
export * from "./SpecialistSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports